<p-drawer
  [(visible)]="drawerVisible"
  [modal]="false"
  [closeOnEscape]="false"
  position="bottom"
  styleClass="fixed right-0 bottom-0 !w-[36rem] max-w-[calc(100vw-2rem)] !h-auto !left-auto top-auto mr-22 md:mr-26 !border-0 !rounded-none"
>
  <ng-template #headless>
    <div class="flex max-h-[30rem] flex-col overflow-hidden rounded-t-2xl border border-slate-200 bg-white shadow-2xl md:max-h-[34rem]">
      <div class="flex items-center justify-between border-b border-slate-200 px-5 py-4">
        <button
          type="button"
          class="min-w-0 flex-1 cursor-pointer bg-transparent text-left"
          (click)="toggleCollapsed()"
        >
          <p class="truncate text-lg font-semibold text-slate-900">Notifications</p>
          <p class="text-sm text-slate-500">
            {{ notificationCenter.runningTasks().length }} in progress
            <span class="mx-1">•</span>
            {{ notificationCenter.completedItems().length }} recent
          </p>
        </button>

        <button
          pButton
          type="button"
          class="p-button-text !h-9 !w-9 !rounded-full !p-0 text-slate-500"
          pTooltip="Closing this panel will not stop uploads or other background tasks."
          tooltipPosition="top"
          (click)="notificationCenter.closeDrawer()"
        >
          <i class="material-icons-outlined !text-base">close</i>
        </button>
      </div>

      @if (!collapsed()) {
      <div class="min-h-0 flex-1 overflow-y-auto px-4 py-4">
        @if (!notificationCenter.visibleItems().length) {
          <div class="flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-200 px-6 py-10 text-center">
            <i class="material-icons-outlined mb-3 text-3xl text-slate-300">notifications_none</i>
            <p class="text-sm font-medium text-slate-700">No notifications yet.</p>
          </div>
        }

        @if (notificationCenter.runningTasks().length) {
          <div class="mb-5">
            <p class="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">In progress</p>
            <div class="flex flex-col gap-2.5">
              <div
                *ngFor="let item of notificationCenter.runningTasks(); trackBy: trackById"
                class="rounded-2xl border border-slate-200 bg-slate-50 p-3.5"
              >
                <div class="flex items-start gap-3">
                  <div class="mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white text-slate-700 shadow-sm">
                    <i class="material-icons-outlined !text-lg">{{ getItemIcon(item) }}</i>
                  </div>

                  <div class="min-w-0 flex-1">
                    <div class="flex flex-wrap items-center gap-2">
                      <p class="min-w-0 flex-1 truncate text-sm font-semibold text-slate-900">{{ item.title }}</p>
                      <span class="rounded-full px-2.5 py-1 text-xs font-semibold" [ngClass]="getStatusClasses(item)">
                        {{ getStatusLabel(item) }}
                      </span>
                    </div>

                    @if (item.message) {
                      <p class="mt-1 text-sm text-slate-600">{{ item.message }}</p>
                    }

                    @if (item.type === 'task') {
                      <div class="mt-3">
                        <div class="h-2 overflow-hidden rounded-full bg-slate-200">
                          <div
                            class="h-full rounded-full bg-slate-900 transition-all duration-300"
                            [style.width.%]="getProgressPercent(item)"
                          ></div>
                        </div>
                        <div class="mt-2 flex items-center justify-between text-xs text-slate-500">
                          <span>{{ item.progress?.current ?? 0 }}/{{ item.progress?.total ?? item.entries?.length ?? 0 }}</span>
                          <span>{{ getProgressPercent(item) }}%</span>
                        </div>
                      </div>
                    }

                    @if (hasEntries(item)) {
                      <button
                        pButton
                        type="button"
                        class="p-button-text mt-3 !px-0 text-sm font-medium text-slate-700"
                        (click)="toggleExpanded(item.id)"
                      >
                        <span class="flex items-center gap-1">
                          <i class="material-icons-outlined !text-base">
                            {{ isExpanded(item) ? 'expand_less' : 'expand_more' }}
                          </i>
                          {{ isExpanded(item) ? 'Hide items' : 'Show items' }}
                        </span>
                      </button>

                      @if (isExpanded(item)) {
                        <div class="mt-3 flex flex-col gap-2 rounded-xl bg-white p-3">
                          <div
                            *ngFor="let entry of item.entries"
                            class="flex items-center justify-between gap-3 border-b border-slate-100 pb-2 last:border-b-0 last:pb-0"
                          >
                            <div class="min-w-0">
                              <p class="truncate text-sm text-slate-800">{{ entry.label }}</p>
                              @if (entry.errorMessage) {
                                <p class="text-xs text-rose-600">{{ entry.errorMessage }}</p>
                              }
                            </div>
                            <div class="shrink-0 text-xs font-semibold text-slate-500">
                              @if (entry.status === 'success') {
                                <span class="text-emerald-600">Done</span>
                              } @else if (entry.status === 'error') {
                                <span class="text-rose-600">Error</span>
                              } @else if (entry.status === 'canceled') {
                                <span class="text-slate-500">Canceled</span>
                              } @else {
                                <span>{{ entry.progress ?? 0 }}%</span>
                              }
                            </div>
                          </div>
                        </div>
                      }
                    }

                    <div class="mt-4 flex flex-wrap gap-2">
                      @if (hasOpenAction(item)) {
                        <span
                          class="inline-flex"
                          [pTooltip]="getOpenActionTooltip(item)"
                          tooltipPosition="top"
                        >
                          <button
                            pButton
                            type="button"
                            class="p-button-sm"
                            [disabled]="isOpenActionDisabled(item)"
                            (click)="openItem(item.id)"
                          >
                            <span pButtonLabel>{{ getOpenLabel(item) }}</span>
                          </button>
                        </span>
                      }

                      @if (canCancel(item)) {
                        <button
                          pButton
                          type="button"
                          class="p-button-sm p-button-text"
                          (click)="cancelTask(item.id)"
                        >
                          <span pButtonLabel>Cancel</span>
                        </button>
                      }

                      @if (canDismiss(item)) {
                        <button
                          pButton
                          type="button"
                          class="p-button-sm p-button-text"
                          (click)="dismiss(item.id)"
                        >
                          <span pButtonLabel>Hide</span>
                        </button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        @if (notificationCenter.completedItems().length) {
          <div>
            <p class="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">Recent</p>
            <div class="flex flex-col gap-2.5">
              <div
                *ngFor="let item of notificationCenter.completedItems(); trackBy: trackById"
                class="rounded-2xl border border-slate-200 bg-white p-3.5"
              >
                <div class="flex items-start gap-3">
                  <div class="mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-slate-50 text-slate-700">
                    <i class="material-icons-outlined !text-lg">{{ getItemIcon(item) }}</i>
                  </div>

                  <div class="min-w-0 flex-1">
                    <div class="flex flex-wrap items-center gap-2">
                      <p class="min-w-0 flex-1 truncate text-sm font-semibold text-slate-900">{{ item.title }}</p>
                      <span class="rounded-full px-2.5 py-1 text-xs font-semibold" [ngClass]="getStatusClasses(item)">
                        {{ getStatusLabel(item) }}
                      </span>
                    </div>

                    @if (item.message) {
                      <p class="mt-1 text-sm text-slate-600">{{ item.message }}</p>
                    }

                    @if (hasEntries(item) && item.entries?.length) {
                      <p class="mt-2 text-xs text-slate-500">
                        {{ item.entries?.length }} items
                      </p>
                    }

                    <div class="mt-4 flex flex-wrap gap-2">
                      @if (hasOpenAction(item)) {
                        <span
                          class="inline-flex"
                          [pTooltip]="getOpenActionTooltip(item)"
                          tooltipPosition="top"
                        >
                          <button
                            pButton
                            type="button"
                            class="p-button-sm"
                            [disabled]="isOpenActionDisabled(item)"
                            (click)="openItem(item.id)"
                          >
                            <span pButtonLabel>{{ getOpenLabel(item) }}</span>
                          </button>
                        </span>
                      }

                      @if (canRemove(item)) {
                        <button
                          pButton
                          type="button"
                          class="p-button-sm p-button-text"
                          (click)="remove(item.id)"
                        >
                          <span pButtonLabel>Remove</span>
                        </button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      }
    </div>
  </ng-template>
</p-drawer>
